// Recovered compiled webpack factory 80413. Edit this function expression; run npm run build.
(e) => {
  (() => {
    "use strict";
    "undefined" != typeof __nccwpck_require__ && (__nccwpck_require__.ab = "//");
    var t = {};
    ((() => {
      function e(e, t) {
        void 0 === t && (t = {});
        for (
          var r = (function (e) {
              for (var t = [], r = 0; r < e.length; ) {
                var n = e[r];
                if ("*" === n || "+" === n || "?" === n) {
                  t.push({ type: "MODIFIER", index: r, value: e[r++] });
                  continue;
                }
                if ("\\" === n) {
                  t.push({ type: "ESCAPED_CHAR", index: r++, value: e[r++] });
                  continue;
                }
                if ("{" === n) {
                  t.push({ type: "OPEN", index: r, value: e[r++] });
                  continue;
                }
                if ("}" === n) {
                  t.push({ type: "CLOSE", index: r, value: e[r++] });
                  continue;
                }
                if (":" === n) {
                  for (var a = "", o = r + 1; o < e.length; ) {
                    var i = e.charCodeAt(o);
                    if (
                      (i >= 48 && i <= 57) ||
                      (i >= 65 && i <= 90) ||
                      (i >= 97 && i <= 122) ||
                      95 === i
                    ) {
                      a += e[o++];
                      continue;
                    }
                    break;
                  }
                  if (!a) throw TypeError("Missing parameter name at ".concat(r));
                  (t.push({ type: "NAME", index: r, value: a }), (r = o));
                  continue;
                }
                if ("(" === n) {
                  var s = 1,
                    l = "",
                    o = r + 1;
                  if ("?" === e[o]) throw TypeError('Pattern cannot start with "?" at '.concat(o));
                  for (; o < e.length; ) {
                    if ("\\" === e[o]) {
                      l += e[o++] + e[o++];
                      continue;
                    }
                    if (")" === e[o]) {
                      if (0 == --s) {
                        o++;
                        break;
                      }
                    } else if ("(" === e[o] && (s++, "?" !== e[o + 1]))
                      throw TypeError("Capturing groups are not allowed at ".concat(o));
                    l += e[o++];
                  }
                  if (s) throw TypeError("Unbalanced pattern at ".concat(r));
                  if (!l) throw TypeError("Missing pattern at ".concat(r));
                  (t.push({ type: "PATTERN", index: r, value: l }), (r = o));
                  continue;
                }
                t.push({ type: "CHAR", index: r, value: e[r++] });
              }
              return (t.push({ type: "END", index: r, value: "" }), t);
            })(e),
            n = t.prefixes,
            o = void 0 === n ? "./" : n,
            i = t.delimiter,
            s = void 0 === i ? "/#?" : i,
            l = [],
            u = 0,
            c = 0,
            f = "",
            d = function (e) {
              if (c < r.length && r[c].type === e) return r[c++].value;
            },
            p = function (e) {
              var t = d(e);
              if (void 0 !== t) return t;
              var n = r[c],
                a = n.type,
                o = n.index;
              throw TypeError("Unexpected ".concat(a, " at ").concat(o, ", expected ").concat(e));
            },
            h = function () {
              for (var e, t = ""; (e = d("CHAR") || d("ESCAPED_CHAR")); ) t += e;
              return t;
            },
            _ = function (e) {
              for (var t = 0; t < s.length; t++) {
                var r = s[t];
                if (e.indexOf(r) > -1) return !0;
              }
              return !1;
            },
            m = function (e) {
              var t = l[l.length - 1],
                r = e || (t && "string" == typeof t ? t : "");
              if (t && !r)
                throw TypeError(
                  'Must have text between two parameters, missing text after "'.concat(t.name, '"'),
                );
              return !r || _(r)
                ? "[^".concat(a(s), "]+?")
                : "(?:(?!".concat(a(r), ")[^").concat(a(s), "])+?");
            };
          c < r.length;

        ) {
          var g = d("CHAR"),
            y = d("NAME"),
            v = d("PATTERN");
          if (y || v) {
            var b = g || "";
            (-1 === o.indexOf(b) && ((f += b), (b = "")),
              f && (l.push(f), (f = "")),
              l.push({
                name: y || u++,
                prefix: b,
                suffix: "",
                pattern: v || m(b),
                modifier: d("MODIFIER") || "",
              }));
            continue;
          }
          var E = g || d("ESCAPED_CHAR");
          if (E) {
            f += E;
            continue;
          }
          if ((f && (l.push(f), (f = "")), d("OPEN"))) {
            var b = h(),
              R = d("NAME") || "",
              P = d("PATTERN") || "",
              S = h();
            (p("CLOSE"),
              l.push({
                name: R || (P ? u++ : ""),
                pattern: R && !P ? m(b) : P,
                prefix: b,
                suffix: S,
                modifier: d("MODIFIER") || "",
              }));
            continue;
          }
          p("END");
        }
        return l;
      }
      function r(e, t) {
        void 0 === t && (t = {});
        var r = o(t),
          n = t.encode,
          a =
            void 0 === n
              ? function (e) {
                  return e;
                }
              : n,
          i = t.validate,
          s = void 0 === i || i,
          l = e.map(function (e) {
            if ("object" == typeof e) return new RegExp("^(?:".concat(e.pattern, ")$"), r);
          });
        return function (t) {
          for (var r = "", n = 0; n < e.length; n++) {
            var o = e[n];
            if ("string" == typeof o) {
              r += o;
              continue;
            }
            var i = t ? t[o.name] : void 0,
              u = "?" === o.modifier || "*" === o.modifier,
              c = "*" === o.modifier || "+" === o.modifier;
            if (Array.isArray(i)) {
              if (!c)
                throw TypeError('Expected "'.concat(o.name, '" to not repeat, but got an array'));
              if (0 === i.length) {
                if (u) continue;
                throw TypeError('Expected "'.concat(o.name, '" to not be empty'));
              }
              for (var f = 0; f < i.length; f++) {
                var d = a(i[f], o);
                if (s && !l[n].test(d))
                  throw TypeError(
                    'Expected all "'
                      .concat(o.name, '" to match "')
                      .concat(o.pattern, '", but got "')
                      .concat(d, '"'),
                  );
                r += o.prefix + d + o.suffix;
              }
              continue;
            }
            if ("string" == typeof i || "number" == typeof i) {
              var d = a(String(i), o);
              if (s && !l[n].test(d))
                throw TypeError(
                  'Expected "'
                    .concat(o.name, '" to match "')
                    .concat(o.pattern, '", but got "')
                    .concat(d, '"'),
                );
              r += o.prefix + d + o.suffix;
              continue;
            }
            if (!u) {
              var p = c ? "an array" : "a string";
              throw TypeError('Expected "'.concat(o.name, '" to be ').concat(p));
            }
          }
          return r;
        };
      }
      function n(e, t, r) {
        void 0 === r && (r = {});
        var n = r.decode,
          a =
            void 0 === n
              ? function (e) {
                  return e;
                }
              : n;
        return function (r) {
          var n = e.exec(r);
          if (!n) return !1;
          for (var o = n[0], i = n.index, s = Object.create(null), l = 1; l < n.length; l++)
            !(function (e) {
              if (void 0 !== n[e]) {
                var r = t[e - 1];
                "*" === r.modifier || "+" === r.modifier
                  ? (s[r.name] = n[e].split(r.prefix + r.suffix).map(function (e) {
                      return a(e, r);
                    }))
                  : (s[r.name] = a(n[e], r));
              }
            })(l);
          return { path: o, index: i, params: s };
        };
      }
      function a(e) {
        return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
      }
      function o(e) {
        return e && e.sensitive ? "" : "i";
      }
      function i(e, t, r) {
        void 0 === r && (r = {});
        for (
          var n = r.strict,
            i = void 0 !== n && n,
            s = r.start,
            l = r.end,
            u = r.encode,
            c =
              void 0 === u
                ? function (e) {
                    return e;
                  }
                : u,
            f = r.delimiter,
            d = r.endsWith,
            p = "[".concat(a(void 0 === d ? "" : d), "]|$"),
            h = "[".concat(a(void 0 === f ? "/#?" : f), "]"),
            _ = void 0 === s || s ? "^" : "",
            m = 0;
          m < e.length;
          m++
        ) {
          var g = e[m];
          if ("string" == typeof g) _ += a(c(g));
          else {
            var y = a(c(g.prefix)),
              v = a(c(g.suffix));
            if (g.pattern)
              if ((t && t.push(g), y || v))
                if ("+" === g.modifier || "*" === g.modifier) {
                  var b = "*" === g.modifier ? "?" : "";
                  _ += "(?:"
                    .concat(y, "((?:")
                    .concat(g.pattern, ")(?:")
                    .concat(v)
                    .concat(y, "(?:")
                    .concat(g.pattern, "))*)")
                    .concat(v, ")")
                    .concat(b);
                } else
                  _ += "(?:"
                    .concat(y, "(")
                    .concat(g.pattern, ")")
                    .concat(v, ")")
                    .concat(g.modifier);
              else {
                if ("+" === g.modifier || "*" === g.modifier)
                  throw TypeError(
                    'Can not repeat "'.concat(g.name, '" without a prefix and suffix'),
                  );
                _ += "(".concat(g.pattern, ")").concat(g.modifier);
              }
            else _ += "(?:".concat(y).concat(v, ")").concat(g.modifier);
          }
        }
        if (void 0 === l || l)
          (i || (_ += "".concat(h, "?")), (_ += r.endsWith ? "(?=".concat(p, ")") : "$"));
        else {
          var E = e[e.length - 1],
            R = "string" == typeof E ? h.indexOf(E[E.length - 1]) > -1 : void 0 === E;
          (i || (_ += "(?:".concat(h, "(?=").concat(p, "))?")),
            R || (_ += "(?=".concat(h, "|").concat(p, ")")));
        }
        return new RegExp(_, o(r));
      }
      function s(t, r, n) {
        if (t instanceof RegExp) {
          var a;
          if (!r) return t;
          for (var l = /\((?:\?<(.*?)>)?(?!\?)/g, u = 0, c = l.exec(t.source); c; )
            (r.push({ name: c[1] || u++, prefix: "", suffix: "", modifier: "", pattern: "" }),
              (c = l.exec(t.source)));
          return t;
        }
        return Array.isArray(t)
          ? ((a = t.map(function (e) {
              return s(e, r, n).source;
            })),
            new RegExp("(?:".concat(a.join("|"), ")"), o(n)))
          : i(e(t, n), r, n);
      }
      (Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.pathToRegexp =
          t.tokensToRegexp =
          t.regexpToFunction =
          t.match =
          t.tokensToFunction =
          t.compile =
          t.parse =
            void 0),
        (t.parse = e),
        (t.compile = function (t, n) {
          return r(e(t, n), n);
        }),
        (t.tokensToFunction = r),
        (t.match = function (e, t) {
          var r = [];
          return n(s(e, r, t), r, t);
        }),
        (t.regexpToFunction = n),
        (t.tokensToRegexp = i),
        (t.pathToRegexp = s));
    })(),
      (e.exports = t));
  })();
}
